__webpack_require__.p = "/astroChannels/";